var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 241,
    viewBox: "0 0 288 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64944 0.383789C3.849 0.383789 0 4.23279 0 9.03323V78.2288C0 80.5228 0.911278 82.7228 2.53336 84.3449C4.15545 85.9669 6.35547 86.8782 8.64944 86.8782H60.5461C62.8401 86.8782 65.0401 85.9669 66.6622 84.3449C68.2843 82.7228 69.1955 80.5228 69.1955 78.2288V26.3321L43.2472 0.383789H8.64944Z",
    fill: "#15161A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.03323C1 4.78508 4.40129 1.38379 8.64944 1.38379H42.833L68.1955 26.7463V78.2288C68.1955 80.2575 67.3896 82.2032 65.9551 83.6378C64.5205 85.0723 62.5749 85.8782 60.5461 85.8782H8.64944C6.62068 85.8782 4.67502 85.0723 3.24047 83.6378C1.80592 82.2032 1 80.2575 1 78.2288V9.03323Z",
    stroke: "url(#paint0_linear_1062_6609)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9485 49.4183C23.0689 49.4183 24.0416 49.603 24.8666 49.9724C25.7038 50.3418 26.3441 50.8712 26.7874 51.5607C27.2306 52.2502 27.4523 53.069 27.4523 54.0171C27.4523 54.9529 27.2306 55.7717 26.7874 56.4735C26.3441 57.163 25.7038 57.6925 24.8666 58.0618C24.0416 58.4312 23.0689 58.6159 21.9485 58.6159H19.0303V62.3467H16.6294V49.4183H21.9485ZM21.8376 56.5843C22.8842 56.5843 23.6784 56.3627 24.2202 55.9194C24.7619 55.4762 25.0328 54.8421 25.0328 54.0171C25.0328 53.1922 24.7619 52.5581 24.2202 52.1148C23.6784 51.6715 22.8842 51.4499 21.8376 51.4499H19.0303V56.5843H21.8376ZM29.64 49.4183H35.2916C36.6706 49.4183 37.8957 49.6892 38.9669 50.2309C40.0381 50.7604 40.8693 51.5176 41.4603 52.5026C42.0513 53.4754 42.3468 54.602 42.3468 55.8825C42.3468 57.163 42.0513 58.2958 41.4603 59.2808C40.8693 60.2535 40.0381 61.0107 38.9669 61.5525C37.8957 62.082 36.6706 62.3467 35.2916 62.3467H29.64V49.4183ZM35.1808 60.3151C36.1289 60.3151 36.96 60.1365 37.6741 59.7795C38.4006 59.4101 38.9546 58.893 39.3363 58.2281C39.7303 57.5509 39.9273 56.769 39.9273 55.8825C39.9273 54.996 39.7303 54.2203 39.3363 53.5554C38.9546 52.8782 38.4006 52.3611 37.6741 52.004C36.96 51.6346 36.1289 51.4499 35.1808 51.4499H32.041V60.3151H35.1808ZM47.0898 51.4314V55.3654H53.3324V57.397H47.0898V62.3467H44.6888V49.4183H54.1265V51.4314H47.0898Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3205 9.14859C44.0605 7.88866 41.9062 8.78099 41.9062 10.5628V24.7344C41.9062 25.8389 42.8017 26.7344 43.9062 26.7344H58.0778C59.8596 26.7344 60.752 24.5801 59.492 23.3202L45.3205 9.14859Z",
    fill: "#15161A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6134 9.8557C43.9834 9.22573 42.9062 9.6719 42.9062 10.5628V24.7344C42.9062 25.2867 43.354 25.7344 43.9062 25.7344H58.0778C58.9687 25.7344 59.4149 24.6572 58.7849 24.0273L44.6134 9.8557Z",
    stroke: "url(#paint1_linear_1062_6609)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.845 0.383789C113.044 0.383789 109.195 4.23279 109.195 9.03323V78.2288C109.195 80.5228 110.107 82.7228 111.729 84.3449C113.351 85.9669 115.551 86.8782 117.845 86.8782H169.741C172.035 86.8782 174.235 85.9669 175.857 84.3449C177.48 82.7228 178.391 80.5228 178.391 78.2288V26.3321L152.443 0.383789H117.845Z",
    fill: "#15161A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.881 9.03323C109.881 4.61158 113.423 1.06964 117.845 1.06964H152.158L177.705 26.6162V78.2288C177.705 80.3409 176.866 82.3664 175.373 83.8599C173.879 85.3533 171.853 86.1924 169.741 86.1924H117.845C115.733 86.1924 113.707 85.3533 112.214 83.8599C110.72 82.3664 109.881 80.3409 109.881 78.2288V9.03323Z",
    stroke: "url(#paint2_linear_1062_6609)",
    strokeOpacity: 0.9,
    strokeWidth: 1.37171
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.723 62.5314C131.418 62.5314 130.236 62.2482 129.177 61.6818C128.131 61.1031 127.306 60.3089 126.702 59.2993C126.111 58.2896 125.816 57.1507 125.816 55.8825C125.816 54.6143 126.118 53.4754 126.721 52.4657C127.324 51.4561 128.149 50.6681 129.196 50.1017C130.255 49.523 131.437 49.2336 132.742 49.2336C133.801 49.2336 134.767 49.4183 135.642 49.7877C136.516 50.1571 137.254 50.6927 137.858 51.3945L136.306 52.8536C135.371 51.8439 134.219 51.3391 132.853 51.3391C131.966 51.3391 131.172 51.5361 130.47 51.9301C129.768 52.3118 129.22 52.8474 128.826 53.5369C128.432 54.2264 128.235 55.0083 128.235 55.8825C128.235 56.7567 128.432 57.5386 128.826 58.2281C129.22 58.9176 129.768 59.4593 130.47 59.8534C131.172 60.235 131.966 60.4259 132.853 60.4259C134.219 60.4259 135.371 59.9149 136.306 58.893L137.858 60.3705C137.254 61.0723 136.51 61.6079 135.623 61.9773C134.749 62.3467 133.782 62.5314 132.723 62.5314ZM143.884 62.5314C142.887 62.5314 141.92 62.3898 140.984 62.1066C140.061 61.8234 139.328 61.4479 138.787 60.98L139.618 59.1146C140.147 59.5332 140.794 59.878 141.557 60.1489C142.333 60.4074 143.108 60.5367 143.884 60.5367C144.845 60.5367 145.559 60.3828 146.027 60.075C146.507 59.7672 146.747 59.3608 146.747 58.856C146.747 58.4866 146.611 58.185 146.341 57.951C146.082 57.7048 145.75 57.5139 145.343 57.3785C144.937 57.2431 144.383 57.0891 143.681 56.9168C142.696 56.6828 141.896 56.4489 141.28 56.2149C140.677 55.981 140.153 55.6178 139.71 55.1253C139.279 54.6204 139.064 53.9432 139.064 53.0937C139.064 52.3795 139.255 51.7331 139.636 51.1544C140.03 50.5634 140.615 50.0955 141.391 49.7508C142.179 49.406 143.139 49.2336 144.272 49.2336C145.06 49.2336 145.836 49.3321 146.599 49.5291C147.362 49.7261 148.021 50.0093 148.575 50.3787L147.818 52.2441C147.252 51.9116 146.661 51.6592 146.045 51.4868C145.429 51.3145 144.832 51.2283 144.254 51.2283C143.305 51.2283 142.597 51.3883 142.13 51.7085C141.674 52.0286 141.446 52.4534 141.446 52.9828C141.446 53.3522 141.576 53.6539 141.834 53.8878C142.105 54.1218 142.444 54.3065 142.85 54.4419C143.256 54.5773 143.81 54.7313 144.512 54.9036C145.472 55.1253 146.26 55.3592 146.876 55.6055C147.492 55.8394 148.015 56.2026 148.446 56.6951C148.889 57.1876 149.111 57.8525 149.111 58.6898C149.111 59.4039 148.914 60.0504 148.52 60.6291C148.138 61.2078 147.553 61.6695 146.765 62.0142C145.977 62.359 145.017 62.5314 143.884 62.5314ZM163.102 49.4183L157.469 62.3467H155.105L149.453 49.4183H152.058L156.361 59.3916L160.701 49.4183H163.102Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.512 9.14859C153.252 7.88866 151.098 8.78099 151.098 10.5628V24.7344C151.098 25.8389 151.993 26.7344 153.098 26.7344H167.269C169.051 26.7344 169.943 24.5801 168.683 23.3202L154.512 9.14859Z",
    fill: "#15161A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.805 9.8557C153.175 9.22573 152.098 9.6719 152.098 10.5628V24.7344C152.098 25.2867 152.545 25.7344 153.098 25.7344H167.269C168.16 25.7344 168.606 24.6572 167.976 24.0273L153.805 9.8557Z",
    stroke: "url(#paint3_linear_1062_6609)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.078 0C222.257 0 218.391 3.86609 218.391 8.68784V78.1906C218.391 80.4948 219.306 82.7045 220.935 84.3338C222.565 85.9631 224.774 86.8784 227.078 86.8784H279.206C281.51 86.8784 283.719 85.9631 285.349 84.3338C286.978 82.7045 287.893 80.4948 287.893 78.1906V26.0635L261.83 0H227.078Z",
    fill: "#15161A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.076 8.68784C219.076 4.24488 222.636 0.685855 227.078 0.685855H261.546L287.208 26.3476V78.1906C287.208 80.3129 286.364 82.3482 284.864 83.8489C283.363 85.3495 281.328 86.1926 279.206 86.1926H227.078C224.956 86.1926 222.921 85.3495 221.42 83.8489C219.92 82.3482 219.076 80.3129 219.076 78.1906V8.68784Z",
    stroke: "url(#paint4_linear_1062_6609)",
    strokeOpacity: 0.9,
    strokeWidth: 1.37171
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M240.903 51.2404H236.599V49.1998H247.618V51.2404H243.314V62.1855H240.903V51.2404ZM256.837 62.1855L253.312 57.251L249.824 62.1855H247.079L251.902 55.5628L247.338 49.1998H250.065L253.386 53.819L256.67 49.1998H259.285L254.74 55.47L259.619 62.1855H256.837ZM263.38 51.2404H259.076V49.1998H270.095V51.2404H265.792V62.1855H263.38V51.2404Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M263.633 8.72671C262.373 7.46678 260.219 8.35912 260.219 10.1409V24.3125C260.219 25.4171 261.114 26.3125 262.219 26.3125H276.39C278.172 26.3125 279.064 24.1582 277.805 22.8983L263.633 8.72671Z",
    fill: "#15161A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M262.926 9.43382C262.296 8.80386 261.219 9.25002 261.219 10.1409V24.3125C261.219 24.8648 261.666 25.3125 262.219 25.3125H276.39C277.281 25.3125 277.727 24.2354 277.097 23.6054L262.926 9.43382Z",
    stroke: "url(#paint5_linear_1062_6609)",
    strokeOpacity: 0.9,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 108.686,
    y: 168.985,
    width: 71.3289,
    height: 71.3289,
    fill: "#202124"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108.686,
    y: 168.985,
    width: 71.3289,
    height: 71.3289,
    stroke: "white",
    strokeWidth: 1.37171
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.349 189.561L138.862 195.047H142.977V207.393H145.72V195.047H149.836M152.579 219.738H136.118C135.391 219.738 134.693 219.449 134.179 218.935C133.664 218.42 133.375 217.722 133.375 216.995V200.534C133.375 199.807 133.664 199.109 134.179 198.594C134.693 198.08 135.391 197.791 136.118 197.791H140.234V200.534H136.118V216.995H152.579V200.534H148.464V197.791H152.579C153.307 197.791 154.004 198.08 154.519 198.594C155.033 199.109 155.322 199.807 155.322 200.534V216.995C155.322 217.722 155.033 218.42 154.519 218.935C154.004 219.449 153.307 219.738 152.579 219.738Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.35 164.3V151.589C144.35 138.334 133.605 127.589 120.35 127.589H58.5977C45.3428 127.589 34.5977 116.844 34.5977 103.589V90.8789",
    stroke: "#C3B6E9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.352 164.299V151.589C144.352 138.334 155.097 127.589 168.352 127.589H229.143C242.398 127.589 253.143 116.844 253.143 103.589V90.8789",
    stroke: "#C3B6E9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.352 164.299V90.8779",
    stroke: "#C3B6E9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_6609",
    x1: 38.9948,
    y1: 5.63111,
    x2: 38.9948,
    y2: 58.2433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_6609",
    x1: 49.7678,
    y1: 16.2344,
    x2: 41.9062,
    y2: 16.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_6609",
    x1: 148.19,
    y1: 5.63111,
    x2: 148.19,
    y2: 58.2433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1062_6609",
    x1: 158.959,
    y1: 16.2344,
    x2: 151.098,
    y2: 16.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1062_6609",
    x1: 257.559,
    y1: 5.27062,
    x2: 257.559,
    y2: 58.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1062_6609",
    x1: 268.08,
    y1: 15.8125,
    x2: 260.219,
    y2: 15.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/Feature_5.b9eaaf6219535c373cb431fa56d12e96.svg";
export { ForwardRef as ReactComponent };